import { useStyles } from './CheckinModal.styles'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import useAppSelector from '../../../../hooks/useAppSelector'
import {
  getCheckedInSelector,
  getDirtyBibSelector,
  getDirtyTagSelector,
  getEnterKeyPressSelector,
  getSelectedEntryTeamSelector,
  setIsAlertMakeBibTagAvailableOpen,
  setIsAlertNoBibNumberOpen,
  setIsAlertNoTagNumberOpen,
} from '../../checkinSlice'
import { Button } from '@mui/material'
import clsx from 'clsx'
import { useCallback, useEffect } from 'react'
import { isRelaySharedBibTeam } from '../../../../components/common/Bib'
import useCheckInEntry from '../../hooks/useCheckInEntry'
import useUnCheckInEntry from '../../hooks/useUnCheckInEntry'
import useCheckinSettings from '../../hooks/useCheckinSettings'

export function CheckInButton({
  buttonText,
  isCheckingIn,
}: {
  buttonText: string
  isCheckingIn: boolean
}) {
  const { classes } = useStyles()
  const dispatch = useAppDispatch()
  const dirtyBib = useAppSelector(getDirtyBibSelector)
  const dirtyTag = useAppSelector(getDirtyTagSelector)
  const enterKeyPress = useAppSelector(getEnterKeyPressSelector)
  const entryAlreadyCheckedIn = useAppSelector(getCheckedInSelector)
  const team = useAppSelector(getSelectedEntryTeamSelector)
  const isRelaySharedBib = team && isRelaySharedBibTeam(team)
  const checkInEntry = useCheckInEntry()
  const uncheckInEntry = useUnCheckInEntry()
  const { checkinAllSettings } = useCheckinSettings()
  const askForTag = checkinAllSettings.settings?.askForTag

  const handleCheckIn = useCallback(() => {
    const missingBib = !dirtyBib && !entryAlreadyCheckedIn
    const missingTag = !!askForTag && !dirtyTag && !entryAlreadyCheckedIn

    if (missingBib || missingTag) {
      dispatch(setIsAlertNoBibNumberOpen(missingBib))
      dispatch(setIsAlertNoTagNumberOpen(missingTag))
      return
    }

    if (!isCheckingIn && !isRelaySharedBib && (dirtyBib || (askForTag && dirtyTag))) {
      dispatch(setIsAlertMakeBibTagAvailableOpen(true))
      return
    }

    if (isCheckingIn) {
      checkInEntry()
    } else {
      uncheckInEntry()
    }
  }, [dispatch, dirtyBib, dirtyTag, askForTag, entryAlreadyCheckedIn, isCheckingIn, isRelaySharedBib, checkInEntry, uncheckInEntry])

  useEffect(() => {
    if (enterKeyPress) {
      handleCheckIn()
    }
  }, [enterKeyPress, handleCheckIn])

  return (
    <Button
      data-cy={'modal-save-btn'}
      onClick={handleCheckIn}
      className={clsx(classes.button, classes.saveButton)}
      variant={'contained'}
    >
      {buttonText}
    </Button>
  )
}
